import { OpportunityCardNew } from "@/components/opportunities/OpportunityCardNew"
import { Opportunity } from "@/hooks/useOpportunitiesApi"

interface OpportunitiesListNewProps {
  opportunities: Opportunity[]
}

export function OpportunitiesListNew({
  opportunities,
}: OpportunitiesListNewProps) {
  return (
    <div className="space-y-8">
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {opportunities.map((opportunity) => (
          <OpportunityCardNew key={opportunity.id} opportunity={opportunity} />
        ))}
      </div>
    </div>
  )
}
